import authModel from './authModel';
import certsModel from './certsModel';

const storeModel = {
	auth: authModel,
	certs: certsModel,
}

export default storeModel;